/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeneratedAccessTokenResource
 */
export interface GeneratedAccessTokenResource {
    /**
     * 
     * @type {string}
     * @memberof GeneratedAccessTokenResource
     */
    token: string;
}

/**
 * Check if a given object implements the GeneratedAccessTokenResource interface.
 */
export function instanceOfGeneratedAccessTokenResource(value: object): value is GeneratedAccessTokenResource {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function GeneratedAccessTokenResourceFromJSON(json: any): GeneratedAccessTokenResource {
    return GeneratedAccessTokenResourceFromJSONTyped(json, false);
}

export function GeneratedAccessTokenResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneratedAccessTokenResource {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function GeneratedAccessTokenResourceToJSON(value?: GeneratedAccessTokenResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

